
import { useLaundryContext } from "providers/LaundryProvider/LaundryProvider"
import { useUI } from "providers/UIProvider"

import { Box, Flex } from "@chakra-ui/react"

import { ICarBodyType, ICarWashType } from "types/laundry"
import { ILaundryServicesProps } from "../LaundryTemplateTypes"

import Heading from "components/UI/atoms/Heading"
import LoundryServicesHeader from "./LaundryServicesHeader"
import LaundryServicesAutoTypes from "./LaundryServicesAutoTypes"
import LaundryServicesTimeAndPrice from "./LaundryServicesTImeAndPrice"
import { validationObject } from "validationSchemas/getLaundryValidationSchema"
import * as Yup from "yup"
import { LAUNDRY_FORM_INITIAL_VALUES } from "utils/constants"
import { useParams } from "react-router-dom"

const LaundryServices: React.FC<ILaundryServicesProps> = ({
  serviceData,
  updateServiceData,
  errors,
  handleBlur,
  touched,
  handleChange,
  values
}) => {
  const { T } = useUI()
  const { laundry } = useLaundryContext()
  const urlParams = useParams()
  const addMode = Boolean(urlParams?.laundryId === "add-laundry")
  const bodyTypes: ICarBodyType[] = laundry?.bodyTypes || []
  const washTypes: ICarWashType[] = bodyTypes[0]?.washTypes || []

  const addToValidation: any = (bodyID: number, washID: number) => {
    // Add BodyWashTypes  keys to validation object
    validationObject[`body${bodyID}Wash${washID}`] = Yup.string().required();

    // Add keys to initial values for validation, AddMode needed because if serviceData had values the validation didn't pass  
    LAUNDRY_FORM_INITIAL_VALUES[`body${bodyID}Wash${washID}`] = addMode ? "" : 0;
  }
  return (
    <Box mt={"40px"} mb={"40px"}>
      <Heading variant="bold" size={"sm"} title={T("loundry.services.title")} />
      <Flex
        flexDirection={"column"}
        borderRadius={"base"}
        mt={"10px"}
        border={"2px"}
        borderColor={"input_border_color_primary"}
        height={"530px"}
        width={"100%"}
      >

        <Flex
          borderTop={"2px"}
          borderColor={"input_border_color_primary"}
          height={"100%"}
          overflow="scroll"
        >

          <Flex
            flexDirection={"column"}
            padding={"4px  18px"}
            alignItems={"center"}
            borderRight={"2px"}
            borderColor={"input_border_color_primary"}
            height={"100%"}
            flex={0.8}
          >
            <Box padding={"53px"} width={"100%"} />

            <Heading variant="bold" size={"sm"} title={T("loundry.car.type")} />
            <Flex mt={"20px"} flexDirection={"column"} gap={"27px"}>
              {bodyTypes.map((bodyType: ICarBodyType) => (
                <LaundryServicesAutoTypes
                  key={bodyType.id}
                  title={bodyType.name}
                  imageUrl={bodyType.imageUrl || ""}
                />
              ))}
            </Flex>

          </Flex>
          <Flex flexDirection="column">
            <Flex justifyContent={"flex-end"} height={"107px"} width={"100%"}>

              {washTypes.map((washType: ICarWashType) => (
                <LoundryServicesHeader
                  key={washType.id}
                  imageUrl={washType.imageUrl || ""}
                  title={washType.name}
                />
              ))}
            </Flex>
            <Flex>
              {washTypes.map((washType: ICarWashType, i: number) => (
                <Flex
                  key={washType.id}
                  flexDirection={"column"}
                  padding={"4px  18px"}
                  alignItems={"center"}
                  borderRight={`${i === washTypes.length - 1 ? "none" : "2px"}`}
                  borderColor={"input_border_color_primary"}
                  height={"100%"}
                  flex={1}
                  gap={"6px"}
                >
                  <Flex width={"100%"} justifyContent={"space-evenly"}>
                    <Heading variant="bold" size={"sm"} title={T("loundry.price")} />
                    <Heading variant="bold" size={"sm"} title={T("loundry.time")} />
                  </Flex>
                  {bodyTypes.map((bodyType: ICarBodyType, j: number) => {
                    addToValidation(bodyType.id, washType.id);
                    return (
                      <Flex key={`body${bodyType.id}Wash${washType.id}`} mt={"20px"} flexDirection={"column"}>
                        {
                          <LaundryServicesTimeAndPrice
                            onBlur={handleBlur}
                            error={Boolean(errors?.[`body${bodyType.id}Wash${washType.id}`] && touched?.[`body${bodyType.id}Wash${washType.id}`])}
                            priceName={`body${bodyType.id}Wash${washType.id}`}
                            timeName={`body${bodyType.id}Wash${washType.id}`}
                            timeOnchange={(e: any) =>
                              updateServiceData(`body${bodyType.id}-wash${washType.id}`, "time", e.value)
                            }
                            timeValue={values?.[`body${bodyType.id}Wash${washType.id}`]?.time || serviceData[`body${bodyType.id}-wash${washType.id}`]?.time}
                            priceValue={values?.[`body${bodyType.id}Wash${washType.id}`]?.price || serviceData[`body${bodyType.id}-wash${washType.id}`]?.price}
                            priceOnChange={(e: any) =>
                              updateServiceData(`body${bodyType.id}-wash${washType.id}`, "price", e.target.value)
                            }
                            priceHandleChange={handleChange}
                          />
                        }
                      </Flex>
                    )
                  })}
                </Flex>
              ))}
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Box>
  )
}

export default LaundryServices
